import Energy from '@/components/game/3d/object/piece/Energy';
import { getColorfromChar } from '@/util/season';

// IF possible to buy (right player, can afford it) display buy button

const PrBuilder = ({ prArr, playerId }) => {
	const energyArray: any = [];

	for (let i = 0; i < prArr.length; i++) {
		energyArray.push(
			<group
				key={`pr_group_${playerId}_${i}`}
				position={[-2 + 1 * i, -1, 4]}
			>
				<Energy
					key={`pr_${playerId}_${i}`}
					energyColor={getColorfromChar(prArr[i])}
				/>
			</group>
		);
	}

	if (!prArr) return;

	return <>{energyArray}</>;
};

export default PrBuilder;
